import { useMutation, useQueryClient } from "@tanstack/react-query";
import { UploadDocumentParams } from "../../common/type";
import documentApi from "../../api/documentApi";

export const useUploadPrivateDocument = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (data: UploadDocumentParams) =>
            documentApi.uploadFile(data),

        onSuccess: (_, variables) => {
            // refetch danh sách document private
            if (variables.isPrivate) {
                queryClient.invalidateQueries({
                    queryKey: ["private-document"],
                });
            }
        },
    });
};
